import Modal from "@insite/mobius/Modal/Modal";

export default Modal;

export * from "./Modal";
